import axios from "axios";
import constant from "../utilities/constants.json";
import { setSiteUnderMaintenanceOutsideReact } from "../utilities/reducer";
let url = constant.server;
const headers = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
};
// COUNTRY CODES
export const countryCodes = (data) => {
  return axios
    .post(url + "country_codes", data, {
      headers: headers,
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// OTP REGISTRATION
export const userRegistrationOtp = (data) => {
  return axios
    .post(url + "send_otp", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const userVerifyOtp = (data) => {
  return axios
    .post(url + "verify_otp", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// UPDATE CONTACT (PHONE / EMAIL)
export const updateContactSendOtp = (data) => {
  return axios
    .post(url + "update_contact_send_otp", data, { headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      }, })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const updateContactVerifyOtp = (data) => {
  return axios
    .post(url + "update_contact_verify_otp", data, { headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },})
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// USER REGISTRATION
export const userRegistration = (data) => {
  return axios
    .post(url + "register", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// USER LOGIN
export const userLogin = (data) => {
  return axios
    .post(url + "login", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// USER Details
export const userDetails = (data) => {
  return axios
    .post(url + "get_user", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status == 1) {
        if (response.data.user_data.language) {
          localStorage.setItem("language", response.data.user_data.language);
        } else if (response.data.status === 103)
          setSiteUnderMaintenanceOutsideReact();

        return response;
      } else if (response.data.status == 101 || response.data.status == 102) {
        localStorage.clear();
        window.location.href = "/";
        return response;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// USER Profile update

export const userProfileUpdate = (data) => {
  return axios
    .post(url + "update_user", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status == 1) {
        if (response.data.user_data && response.data.user_data.language) {
          localStorage.setItem(
            "language",
            response.data.user_data.language.toLowerCase(),
          );
        }

        return response;
      } else if (response.data.status == 101 || response.data.status == 102) {
        localStorage.clear();
      } else if (response.data.status === 103) {
        setSiteUnderMaintenanceOutsideReact();
        return response;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// USER LOGOUT
export const userLogout = (data) => {
  return axios
    .post(url + "logout", data, {
      headers: { Authorization: "Bearer " + `${localStorage.webKey}` },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const userDelete = (data) => {
  return axios
    .post(url + "account-delete", data, {
      headers: { Authorization: "Bearer " + `${localStorage.webKey}` },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// BANNER
export const getBanners = (data) => {
  return axios
    .post(url + "banners", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// Super League  TEAMS
export const getTeams = (data) => {
  return axios
    .post(url + "teams", data)
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// UPLOAD IMAGE

export const profileImageUpload = (data) => {
  return axios
    .post(url + "update_image", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const checkUser = (data) => {
  return axios
    .post(url + "check_user", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const changePassword = (data) => {
  return axios
    .post(url + "change_password", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const offerEligibility = (data) => {
  return axios
    .post(url + "offer_eligibility", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPlayCoins = (data) => {
  return axios
    .post(url + "get_playcoins", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const clickLog = (data) => {
  return axios
    .post(
      url + "clicklog",
      {},
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + `${localStorage.webKey}`,
        },
      },
    )
    .then((response) => {
      if (response.data.status === 103) setSiteUnderMaintenanceOutsideReact();
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserScoreProfile = (data) => {
  return axios
    .post(url + "get_score_profile", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status == 1) {
        return response;
      } else if (response.data.status == 101 || response.data.status == 102) {
        localStorage.clear();
        return response;
      } else if (response.data.status === 103)
        setSiteUnderMaintenanceOutsideReact();
    })
    .catch((err) => {
      console.log(err);
    });
};
